import script from "./StatsRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatsRow.vue?vue&type=script&lang=ts&setup=true"

import "./StatsRow.vue?vue&type=style&index=0&id=2a9fcbb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9fcbb0"]])

export default __exports__